module.exports = "\n<nb-checkbox [(ngModel)]=\"rowData.disabled\" status=\"danger\"></nb-checkbox>\n"